/* eslint-disable no-return-assign */
import React, { useState } from 'react';
import { useEffect } from 'react';
import TextBox from '../../../../components/common/TextBox';
import ApplyButton from '../../../../components/common/ApplyButton';
import BorderButton from '../../../../components/Controller/ActionPanel/BorderButton';
import CurvedText from '../../../../components/Controller/ActionPanel/CurvedText';

const BackText = ({
  options,
  selectedPart,
  partsConfig,
  updatePartsConfig,
  tShirtBikeBackText,
  setBackBikeText,
  currentActiveParent
}) => {
  const [isNormal, setIsNormal] = useState(true);
  const [text, setText] = useState(tShirtBikeBackText[0].line);

  const normalIndex = options.indexOf(
    options.filter(option => option.name === 'BACK_TEXT_ONLY')[0]
  );
  const curvedIndex = options.indexOf(
    options.filter(option => option.name === 'BACK_TEXT_CURVED')[0]
  );

  useEffect(() => {
    if (selectedPart && options[normalIndex]) {
      const bool = selectedPart === options[normalIndex].partId;
      setIsNormal(bool);
    }
  }, [partsConfig.backText, options]);

  return (
    <div className="back-text">
      <div className="back-text_text">
        {isNormal ? (
          <h1 className="back-text_text-normal">{text || 'Your Text'}</h1>
        ) : (
          <h1 className="back-text_text-arc">
            <CurvedText text={text || 'Your Text'} radius={160} />
          </h1>
        )}
      </div>
      <div className="angle_text">
        <TextBox
          name="text-1"
          placeholder="type your text"
          maxLength={15}
          value={text}
          onChange={value => {
            setText(value);
          }}
        />
      </div>
      <div
        className="angle_text_btn"
        style={{
          opacity: text === tShirtBikeBackText[0].line ? 0.3 : 1
        }}
      >
        <ApplyButton
          disabled={text === tShirtBikeBackText[0].line}
          label="apply"
          onClick={() => {
            setBackBikeText(text);
            updatePartsConfig(
              isNormal ? options[normalIndex] : options[curvedIndex],
              'backText'
            );
          }}
        />
      </div>
      <div className="back-text_buttons">
        <BorderButton
          isSelected={isNormal}
          label="normal"
          onClick={() => {
            setIsNormal(true);
            updatePartsConfig(options[normalIndex], 'backText');
          }}
        />
        <BorderButton
          isSelected={!isNormal}
          label="ARC"
          onClick={() => {
            setIsNormal(false);
            updatePartsConfig(options[curvedIndex], 'backText');
          }}
        />
      </div>
    </div>
  );
};

export default BackText;
